import { Box, Circle, Text } from '@factorialco/deprecated-design-system'
import { PointTooltipProps, Serie } from '@nivo/line'

import { ChartData } from '../Table/types'
import { CentToFormattedAmount, findHoveredPoints } from './helpers'

const Tooltip = (
  series: Serie[],
  chartData: ChartData[],
  toAmount: (value: number) => CentToFormattedAmount
) => {
  const Component = ({ point }: PointTooltipProps) => {
    if (point.data.xFormatted !== 'End' && point.data.xFormatted !== 'Start') {
      const points = findHoveredPoints(point, series)

      return points.map(({ x, y, serieId }) => {
        const category = chartData.find((obj) => obj.serieId === serieId)
        return (
          <Box
            gap="s8"
            padding="s12"
            key={serieId}
            background="white"
            borderRadius={{ all: 'abs016' }}
            style={{ boxShadow: '0px 4px 20px 0px #0D162514' }}
            border={{ all: { color: 'grey200', width: 's1', style: 'solid' } }}
          >
            <Box flexDirection="row" gap="s8" alignItems="center">
              <Box>
                <Circle size={8} color={category?.pointColor} />
              </Box>
              <Text.Normal color="grey1000" weight="bold" size="100">
                {`${x}`}
              </Text.Normal>
            </Box>
            <Box flexDirection="row" gap="s32">
              <Text.Normal size="100">Total</Text.Normal>
              <Text.Normal color="grey1000" size="100">{`${
                toAmount(Number(y)).amount
              }`}</Text.Normal>
            </Box>
          </Box>
        )
      })
    }
  }

  return Component
}

export { Tooltip }
